import React from "react";
import Icon2 from '../Images/Icon2.svg';
import Icon1 from '../Images/Icon1.svg';
import Image8 from '../Images/Image8.svg';
import Image10 from '../Images/Image10.svg';
import Image11 from '../Images/Image11.svg';
import Image12 from '../Images/Image12.svg';
import Image13 from '../Images/Image13.svg';
import Image9 from '../Images/Image9.svg';
import PlayStore from '../Images/PlayStore.svg';
import Footer from "./Footer";
import HeaderContent from "./Header";

export default function DespatchKnowMore() {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <div
      style={{
        height: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "white",
        overflowX: 'hidden'
      }}
    >

      <HeaderContent />
      {/* Main Centered Content */}

      {/* First Part */}
      <div className="section-container">
        {/* Internal CSS */}
        <style>
          {`
    .section-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 40px 60px;
      background-color: white;
    }

    .section-text {
      flex: 1;
      color: #000;
      text-align: left;          /* ✅ Always left-aligned */
      display: flex;
      flex-direction: column;
      align-items: flex-start;   /* ✅ Aligns child elements to the left */
    }

    .section-text h3 {
      font-size: 18px;
      color: #FA4A0C;
      margin: 0;
    }

    .section-text h1 {
      font-size: 42px;
      margin: 15px 0;
      line-height: 1.2;
      text-align: left;          /* ✅ Ensure text inside h1 also aligns left */
      width: 100%;
    }

    .section-text p {
      font-size: 16px;
      color: #555;
      text-align: left;          /* ✅ Paragraph also starts left */
      width: 100%;
    }

    .section-image {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .section-image img {
      width: 100%;
      max-width: 1000px;
      height: auto;
    }

    /* 📱 Responsive */
    @media (max-width: 768px) {
      .section-container {
        flex-direction: column;
        align-items: flex-start;   /* ✅ Keep text on left even on small screens */
        text-align: left;
        padding: 10px 20px;
      }

      .section-text {
        align-items: flex-start;   /* ✅ No centering on mobile */
        text-align: left;
      }

      .section-text h1 {
        font-size: 28px;
      }

      .section-text p {
        font-size: 14px;
      }

      .section-image img {
        max-width: 100%;
      }
    }
  `}
        </style>

        {/* Left Side - Text */}
        <div className="section-text" style={{ lineHeight: 0.1 }}>
          <h3>Get Started</h3>
          <h1 style={{ lineHeight: 1.4 }}>
            Delivery Service <br /> For{" "}
            <span style={{
              backgroundColor: '#FA4A0C',
              borderRadius: '18px',
              padding: '0px 5px 5px 5px',
              color: 'white',

            }}>
              Business
            </span>
          </h1>
          <p style={{ maxWidth: '60%', lineHeight: 1.4 }}>
            Increase your Local and Offline Delivery into Online and Make your Business Wider & Longer.
          </p>
          <p>
            <img src={Image9} alt="Business delivery support"
              style={{ borderRadius: 30, verticalAlign: 'middle', marginTop: 1 }} width="24" height="24" />
            <span style={{ marginLeft: 10 }}>Add your business in next level</span>
          </p>

          <p>
            <img src={Image9} alt="Business delivery support"
              style={{ borderRadius: 30, verticalAlign: 'middle', marginTop: 1 }} width="24" height="24" />
            <span style={{ marginLeft: 10 }}>We provide delivery services at any time</span>
          </p>
          <img src={PlayStore} alt="Business delivery support" width="150" height="50" />
        </div>

        {/* Right Side - SVG Image */}
        <div className="section-image">
          <img src={Image8} alt="Business delivery support" width="400" height="350" />
        </div>
      </div>

      <div className="section-container1">

        <div className="main">
          <style>
            {`
          .main {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
            width: 100%;
            background-color: white;
            padding: 20px;
          }

          .main h1 {
            color: black;
            font-size: 33px;
            margin: 5px 0;
            line-height: 1.2;
          }

          /* 📱 Mobile Responsive */
          @media (max-width: 768px) {
            .main h1 {
              font-size: 24px;
            }
          }
        `}
          </style>
          <div style={{ lineHeight: 0.2 }}>
            <h6 style={{ color: '#6E51E0', }}>Our Services</h6>
            <h1>Our App Provides</h1>
          </div>

        </div>
        <style>
          {`
      .section-container1 {
        width: 100%;
        max-width: 1500px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        gap: 0px; /* space between rows */
      }

      .section-row {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .text-box {
        background: white;
        display: flex;
        align-items: center;
        gap: 0px;
        padding: 10px;
       
        width: 80%;
        max-width: 2000px;
        text-align: left;
      }

      .image-box {
        flex: 0 0 300px;
        display: flex;
        justify-content: center;
      }

      .image-box img {
        width: 100%;
        max-width: 800px;
        border-radius: 20px;
        object-fit: cover;
      }

      .text-box-content {
        flex: 1;
        padding: 0px 0px 50px 50px;
        border-radius: 20px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        background:#F4F5FA
      }

      .text-box-content h2 {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 15px;
        color: #333;
      }

      .text-box-content p {
        font-size: 16px;
        line-height: 1.6;
        color: #555;
      }

      

      /* 📱 Responsive Design */
      @media (max-width: 768px) {
        .text-box {
          flex-direction: column;
          text-align: center;
          padding: 20px;
        }

        .image-box {
          flex: 0 0 auto;
        }

        .image-box img {
          max-width: 300px;
        }
      }
    `}
        </style>

        {/* Row 1 */}
        <div className="section-row">
          <div className="text-box">
            
            <div className="text-box-content" >
              <h2><img src={Icon2} alt="Business delivery support"
                style={{ borderRadius: 30, verticalAlign: 'middle', marginTop: 1 }} width="24" height="24" />{' '}Customer Focus</h2>
              <p style={{ maxWidth: '70%', lineHeight: 2.7 }}>
                The design and features are built with strong customer focus to ensure every order is handled quickly and accurately. By allowing hotel owners to track deliveries in real time, manage orders easily, and communicate clearly with delivery partners,
              </p>
            </div>
            <div className="image-box">
              <img src={Image10} alt="Grow Business" width="300" height="300" />
            </div>
          </div>
        </div>

        {/* Row 2 */}
        <div className="section-row">
          <div className="text-box">
<div className="image-box">
              <img src={Image11} alt="Fast Delivery" width="300" height="300" />
            </div>
            <div className="text-box-content" style={{ lineHeight: 1 }}>
              <h2><img src={Icon1} alt="Business delivery support"
                style={{ borderRadius: 30, verticalAlign: 'middle', marginTop: 1 }} width="24" height="24" />{' '}Available Partners</h2>
              <p style={{ maxWidth: '70%', lineHeight: 2.7 }}>The View Available Partners section helps hotel owners see all nearby delivery partners who are currently active and ready to take orders. The screen displays each partner’s name, contact number, distance from the hotel, and their current availability status. </p>
            </div>
            
          </div>
        </div>

        {/* Row 3 */}
        <div className="section-row">
          <div className="text-box">
            
            <div className="text-box-content">
              <h2><img src={Icon2} alt="Business delivery support"
                style={{ borderRadius: 30, verticalAlign: 'middle', marginTop: 1 }} width="24" height="24" />{' '}Live Tracking</h2>
              <p style={{ maxWidth: '70%', lineHeight: 2.7 }}>Live Tracking feature allows hotel owners to see the real-time location of their delivery partner once an order is accepted. Using the integrated map, the owner can track every stage of the delivery </p>
            </div>
            <div className="image-box">
              <img src={Image12} alt="24/7 Service" width="300" height="300" />
            </div>
          </div>
        </div>

        {/* Row 4 */}
        <div className="section-row">
          <div className="text-box">
            <div className="image-box">
              <img src={Image13} alt="Customer Satisfaction" width="300" height="300" />
            </div>
            <div className="text-box-content">
              <h2><img src={Icon1} alt="Business delivery support"
                style={{ borderRadius: 30, verticalAlign: 'middle', marginTop: 1 }} width="24" height="24" />{' '}Lowest Maintenance cost</h2>
              <p style={{ maxWidth: '70%', lineHeight: 2.7 }}>The Hotel Owner App offers delivery services at the lowest possible cost, making it affordable for small hotels and restaurants. By connecting hotel owners directly with nearby delivery partners, the app removes middlemen and reduces extra charges.</p>
            </div>
            
          </div>
        </div>
        <div style={{height:50}}></div>
      </div>
      <Footer />

    </div>

  );
}   
